/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react'
import './MonCompte.css'
import {Menu} from './Menu'
import {VosAbonnements} from './Abonnements/VosAbonnements'
import {VosCommandes} from './Commandes/VosCommandes'
import {BesoinAide} from './Aide/BesoinAide'
import {VosAdressesContacts} from './AdressesContact/VosAdressesContacts'
import {Connexions} from './Connexions/Connexions'
import {NousContacter} from './Aide/NousContacter'
import { ClientService } from '../../../Services/Client/ClientService'
import { useCookies } from 'react-cookie'
import { Client } from '../../../Models/Client/ClientModels'
import { Grid, Skeleton, SvgIcon } from '@mui/material'
import { Entete } from '../../Entete/Entete';
import {
  faHouse
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useOutletContext } from 'react-router-dom'
import { Magasin } from '../../../Models/Magasin/MagasinModels'
import { MagasinService } from '../../../Services/Magasin/MagasinService'
import SvgIcoMonCompte from '../../../img/MonCompte/ICO_MonCompte'

export function MonCompte() {
  //attributes
  const [interfaceMonCompte, setInterfaceMonCompte] = useState<number>(0)
  const [client, setClient] = useState<Client>({
    id:0,
    actif:false,
    adresse:'',
    email:'',
    nom:'',
    magasins:[],
    numeroClient:'',
    identifiants:[]
  });
  // const [magasins, setMagasins] = useState<Magasin[]>([]);

  const [cookies] = useCookies(['token'])
  const [loading, setLoading] = useState<boolean>(true);

  //API attributes
  const token = cookies.token;

  const contextDonnees = useOutletContext<any[]>(); 
  const obtentionDonnees:()=>Promise<void> = contextDonnees[3];
  const magasinsContext:Magasin[] = contextDonnees[5];
  console.log(magasinsContext)

  //use effect to initialize numeroClient
  useEffect(()=>{
    async function infoClient(){
      if(token){
        // const magasinsResult = await MagasinService().getMagasinsUtilisateruWithAllDatas(token);
        const resultClient = await ClientService().getClientForMonCompte(token);
        // setMagasins(magasinsResult);
        setClient(resultClient);
        setLoading(false);
      }
    }
    obtentionDonnees();
    infoClient();
    return ()=>{

    }
  }, [obtentionDonnees, token]);

  //gestion drawer depuis entete
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const [backHover, setBackHover] = useState<Boolean>(false)

  //return jsx
  return (
    <>
      <div className='container-entete'>
        <Entete mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isClosing={isClosing} setIsClosing={setIsClosing}/>
      </div>
      <div className="container-interface">
        <div className="Interface">
           <div className='MonCompte'>
            <div className='MonCompte-client'>
              <Link style={{marginRight:'8px'}} to={'../accueil'}>
                <FontAwesomeIcon
                  icon={faHouse}
                  style={backHover ? { color: '#7984ba' } : {color: 'black'}}
                  onMouseEnter={() => setBackHover(true)}
                  onMouseLeave={() => setBackHover(false)}
                  size='1x'
                />
              </Link>
              <div style={{marginLeft:'8px'}}>|</div>
              <SvgIcon sx={{fontSize:'3rem'}} className='iconCompte' component={SvgIcoMonCompte} inheritViewBox/>
              <p className='MonCompte-monCompte' style={{ color: 'var(--violet)' }}>
                Mon compte
              </p>
              {
                (!loading)?<p className='MonCompte-numero-client'>Numéro client : {client.numeroClient}</p>:
                <>
                    <p className='MonCompte-numero-client'>Chargement...</p>
                </>
              }
            </div>
            {
              (loading)?
              <Grid container spacing={2} sx={{m:1, justifyContent:'center'}}>
                {
                  ['','','','','',''].map((val, index)=>(
                    <Grid key={index}>
                      <Skeleton variant="rectangular" sx={{m:1}} width={210} height={118}/>
                    </Grid>
                  ))
                }
              </Grid>:
              <div className='MonCompte-menu'>
                {interfaceMonCompte === 0 && (
                  <Menu setInterfaceMonCompte={setInterfaceMonCompte} />
                )}
                {interfaceMonCompte === 1 && (
                  <VosAbonnements
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte}
                    magasins={magasinsContext}
                  />
                )}
                {interfaceMonCompte === 2 && (
                  <VosCommandes
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte}
                  />
                )}
                {interfaceMonCompte === 3 && (
                  <BesoinAide
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte}
                  />
                )}
                {interfaceMonCompte === 4 && (
                  <VosAdressesContacts
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte} 
                    magasinsClient={magasinsContext}
                    obtentionDonnees={obtentionDonnees}
                  />
                )}
                {interfaceMonCompte === 5 && (
                  <Connexions
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte}
                    magasins={magasinsContext}
                  />
                )}
                {interfaceMonCompte === 6 && (
                  <NousContacter
                    setInterfaceMonCompte={setInterfaceMonCompte}
                    interfaceMonCompte={interfaceMonCompte}
                  />
                )}
              </div>
            }
            </div>
        </div>
      </div>
    </>
  )
}
